// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuetify from "vuetify";
// import Vuex from 'vuex'
// import { store } from './store'
import store from "./store";
import axios from "axios";
import VueFormGenerator from "vue-form-generator";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

import Buefy from "buefy";
import "buefy/lib/buefy.css";

import {
  DatePicker,
  TimePicker,
  TimeSelect,
  Form,
  FormItem,
  Input,
  InputNumber,
  Button,
  Select,
  Option,
  Radio,
  RadioGroup,
  Tag,
  Checkbox,
  Autocomplete,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Table,
  TableColumn,
  Pagination,
  Loading,
  Card,
  Col,
  Row
} from "element-ui";
import infiniteScroll from "vue-infinite-scroll";
import VeeValidate from "vee-validate";

// import Print from 'vue-print-nb'
// import 'element-ui/lib/theme-chalk/index.css'

// Internationalization
// elementUI
// (http://element.eleme.io/#/en-US/component/i18n)
// #shankar
locale.use(lang);

Vue.use(Vuetify);
Vue.use(VueFormGenerator);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(TimeSelect);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(VeeValidate);
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Tag);
Vue.use(Checkbox);
Vue.use(Autocomplete);
Vue.use(Buefy);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);

Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Loading);
Vue.use(Row);
Vue.use(Col);
Vue.use(Card);
Vue.use(infiniteScroll);

// Vue.use(Print);

// Vue.use(VueFormly);
// Vue.use(Vuetify, {
//   theme: {
//     primary: '#018FFF',
//     secondary: '#383B3F',
//     accent: '#74CB74',
//     error: '#D85959'
//   }
// });
Vue.config.productionTip = false;

// axios interceptor
const token = localStorage.getItem("token");
axios.defaults.headers["Content-Type"] = "application/json";

axios.interceptors.request.use(
  function(config) {
    if (token) {
      config.headers.token = token;
    }
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    console.log(error.response);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    if (response.status === 401) {
      //TODO: API returns "token Missing" for other things too. So can't use response interceptor for route gaurding
      localStorage.clear();
      window.location.href = "/";
    }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  template: "<App/>",
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js